import React from "react";

import clickWrap from "@js/helpers/click_wrap.js";

const ModalActionButton = function(props) {
  let classNames = [
    "button",
    "btn",
    "btn-close",
    "button-with-feedback-on-click",
  ];

  if (props.dangerous) {
    classNames.push("btn-danger");
    classNames.push("dangerous-button");
  } else if (props.diminished) {
    classNames.push("diminished-button");
  } else {
    classNames.push("btn-primary");
  }
  let style = {};
  if (props.style) {
    style = {
      ...style,
      ...props.style,
    };
  }
  return props.onClick ? (
    <button
      className={classNames.join(" ")}
      onClick={clickWrap(props.onClick)}
      style={style}
    >
      {props.text}
    </button>
  ) : null;
};

export default ModalActionButton;
